<template>
  <div>
    <el-descriptions :column="5">
      <el-descriptions-item
        :label="$l('INDEX.goods_label_orderGoodsName') || '产品名称'"
        :span="2"
      >
        {{ formData.orderGoodsDisplayName }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_label_goodsSpecDisplay') || '产品规格'"
        :span="2"
      >
        {{ formData.goodsSpecDisplay }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_label_masterCategory') || '分类名称'"
        :span="1"
      >
        {{ `${formData.masterCategoryName} ${formData.masterCategoryNameEn}` }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_label_singleGoodsNetWeight') || '单品净重(kg)'"
        :span="2"
        :label-class-name="totalGoodsWeightExcess ? 'content-excess' : ''"
        :content-class-name="totalGoodsWeightExcess ? 'content-excess' : ''"
      >
        {{ singleGoodsNetWeight }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.shipment_batch_box_goods_goodsPrice') || '工厂单价'"
        :span="2"
        :label-class-name="totalGoodsPriceExcess ? 'content-excess' : ''"
        :content-class-name="totalGoodsPriceExcess ? 'content-excess' : ''"
      >
        {{ formData.v_goodsPrice }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="
          $l('INDEX.shipment_batch_box_goods_goodsSalePrice') || '客人单价'
        "
        :span="1"
        :label-class-name="totalGoodsSalePriceExcess ? 'content-excess' : ''"
        :content-class-name="totalGoodsSalePriceExcess ? 'content-excess' : ''"
      >
        {{ formData.v_goodsSalePrice }}
      </el-descriptions-item>
    </el-descriptions>
    <el-form ref="form" :model="formData" size="mini">
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_label_isUseGroupHsCode') || '报关方式'"
          >
            <br />
            <el-radio-group
              v-model="formData.isUseGroupHsCode"
              @change="onIsUseGroupHsCodeChange"
            >
              <el-radio-button label="N">
                {{
                  $l('INDEX.form_label_isUseGroupHsCode_detail') || '明细报关'
                }}
              </el-radio-button>
              <el-radio-button label="Y">
                {{
                  $l('INDEX.form_label_isUseGroupHsCode_goods') || '产品报关'
                }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="$l('INDEX.shipment_customs_code_hscode') || '报关HSCODE'"
            required
            :error="hscodeError"
          >
            <HscodeSelect
              :hscode="formData.hscode"
              @change="onHscodeChange"
              :categoryCode="masterCategoryCode"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="$l('INDEX.form_label_hscodeName') || '报关中文名称'"
          >
            <el-input
              v-model="formData.hscodeName"
              :placeholder="
                $l('INDEX.form_placeholder_hscode') || '请选择报关HSCODE'
              "
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="$l('INDEX.form_label_hscodeNameEn') || '报关英文名称'"
          >
            <el-input
              v-model="formData.hscodeNameEn"
              :placeholder="
                $l('INDEX.form_placeholder_hscode') || '请选择报关HSCODE'
              "
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mt-1">
        <GoodsSpecTable
          ref="goodsSpecTable"
          :shipmentCode="shipmentCode"
          :orderGoodsCode="orderGoodsCode"
          :masterCategoryCode="masterCategoryCode"
          :currencyUnit="formData.v_currencyUnit"
          :salesCurrencyUnit="formData.v_salesCurrencyUnit"
          @change="onGoodsSpecTableChange"
          :disabledHsCode="formData.isUseGroupHsCode === 'Y'"
        />
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="mini">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="mini">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="mini">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import HscodeSelect from '../hscode-select'
import GoodsSpecTable from '../goods-spec/table'
import { add, divideDown } from '@/libs/util.number.js'
export default {
  components: { HscodeSelect, GoodsSpecTable },
  mixins: [EditLoading],
  props: {
    shipmentCode: { type: String, default: '' },
    orderGoodsCode: { type: String, default: '' },
    masterCategoryCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      totalGoodsWeight: 0,
      totalGoodsPrice: 0,
      totalGoodsSalePrice: 0,
      hscodeError: '',
    }
  },
  computed: {
    singleGoodsNetWeight() {
      return divideDown(
        this.formData.totalInPackageNetWeight,
        this.formData.totalInPackageQty,
        2
      )
    },
    totalGoodsWeightExcess() {
      if (this.formData.isUseGroupHsCode === 'Y') return false
      return this.totalGoodsWeight != this.singleGoodsNetWeight
    },
    totalGoodsPriceExcess() {
      if (this.formData.isUseGroupHsCode === 'Y') return false
      return this.totalGoodsPrice != this.formData.goodsPrice
    },
    totalGoodsSalePriceExcess() {
      if (this.formData.isUseGroupHsCode === 'Y') return false
      return this.totalGoodsSalePrice != this.formData.goodsSalePrice
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.shipmentCode || !this.orderGoodsCode) return
      const res = await this.$api
        .shipmentBatchBoxGoodsDetailApi({
          shipmentCode: this.shipmentCode,
          orderGoodsCode: this.orderGoodsCode,
        })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    onHscodeChange(e) {
      const { hscode = '', hscodeName = '', hscodeNameEn = '' } = e || {}

      this.hscodeError = !hscode
        ? this.$l('INDEX.form_placeholder_hscode') || '请选择报关HSCODE'
        : ''

      this.formData.hscode = hscode
      this.formData.hscodeName = hscodeName
      this.formData.hscodeNameEn = hscodeNameEn
      this.onIsUseGroupHsCodeChange(this.formData.isUseGroupHsCode)
    },
    onGoodsSpecTableChange(e) {
      if (!e || !e.length) return
      const {
        totalGoodsWeight,
        totalGoodsPrice,
        totalGoodsSalePrice,
      } = e.reduce(
        (result, next) => {
          result.totalGoodsWeight = add(
            result.totalGoodsWeight,
            next.totalGoodsSpecWeight
          )
          result.totalGoodsPrice = add(
            result.totalGoodsPrice,
            next.totalGoodsSpecPrice
          )
          result.totalGoodsSalePrice = add(
            result.totalGoodsSalePrice,
            next.totalGoodsSpecSalePrice
          )
          return result
        },
        {
          totalGoodsWeight: 0,
          totalGoodsPrice: 0,
          totalGoodsSalePrice: 0,
        }
      )
      this.totalGoodsWeight = totalGoodsWeight
      this.totalGoodsPrice = totalGoodsPrice
      this.totalGoodsSalePrice = totalGoodsSalePrice
    },
    onIsUseGroupHsCodeChange(e) {
      if (e === 'N') return
      const { hscode, hscodeName, hscodeNameEn } = this.formData
      this.$refs.goodsSpecTable.setHscode({
        hscode,
        hscodeName,
        hscodeNameEn,
      })
    },
    async formValidate() {
      const { hscode } = this.formData
      if (!hscode) {
        this.hscodeError =
          this.$l('INDEX.form_placeholder_hscode') || '请选择报关HSCODE'
      }

      const specResult = await this.$refs.goodsSpecTable.validate()
      if (
        !!hscode &&
        specResult &&
        !this.totalGoodsWeightExcess &&
        !this.totalGoodsPriceExcess &&
        !this.totalGoodsSalePriceExcess
      ) {
        return true
      }

      if (this.totalGoodsWeightExcess) {
        this.$message({
          message: `规格总净重[${this.totalGoodsWeight}kg]不等于产品单品净重[${this.singleGoodsNetWeight}kg]`,
          type: 'warning',
          showClose: true,
        })
      }
      if (this.totalGoodsPriceExcess) {
        setTimeout(() => {
          this.$message({
            message: `规格工厂金额[${this.totalGoodsPrice} ${this.formData.v_currencyUnit}]不等于产品工厂单价[${this.formData.v_goodsPrice}]`,
            type: 'warning',
            showClose: true,
          })
        }, 0)
      }
      if (this.totalGoodsSalePriceExcess) {
        setTimeout(() => {
          this.$message({
            message: `规格客人金额[${this.totalGoodsSalePrice} ${this.formData.v_salesCurrencyUnit}]不等于产品客人单价[${this.formData.v_goodsSalePrice}]`,
            type: 'warning',
            showClose: true,
          })
        }, 0)
      }
      return false
    },
    async save() {
      const result = await this.formValidate()
      if (!result) return (this.backDialogVisible = false)
      const listGoodsSpec = this.$refs.goodsSpecTable.getTableData()

      const listGoodsSpecParams = listGoodsSpec.map((item) => {
        return { ...item, orderGoodsSpecCodeList: [item.orderGoodsSpecCode] }
      })

      const params = {
        ...this.formData,
        orderGoodsCodeList: [this.formData.orderGoodsCode],
      }
      this.loadingOpen()
      const res = await this.$api
        .shipmentHscodeGoodsSaveAndSyncCustomerGoodsApi(params)
        .catch(() => null)
      const { status } = res || {}
      if (status !== 200) {
        this.loadingClose()
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }

      const listTask = listGoodsSpecParams.map((goodsSpec) =>
        this.$api
          .shipmentHscodeGoodsSpecSaveAndSyncCustomerGoodsApi(goodsSpec)
          .then((res) => {
            if (res.status !== 200) return null
            return res
          })
          .catch(() => null)
      )
      const listRes = await Promise.all(listTask)
      this.loadingClose()
      if (listRes.includes(null)) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-descriptions__header {
  margin-bottom: 10px;
}

::v-deep .content-excess {
  color: red;
}
</style>
